import React from "react";
import { Link } from "react-router-dom";

const SOCIALS = [
  {
    href: "https://x.com/bleep_app_",
    icon: "fab fa-x-twitter",
    label: "Follow on X",
  },
  {
    href: "https://www.instagram.com/bleep_ug",
    icon: "fab fa-instagram",
    label: "Follow on Instagram",
  },
  {
    href: "https://www.linkedin.com/company/bleepapp/posts/?feedView=all",
    icon: "fab fa-linkedin-in",
    label: "Follow on LinkedIn",
  },
];

// Styling lives in src/styles/bleep-theme.css (`.footer-*`). The root has no
// `bleep-light`, so the tokens resolve to the dark scale on every page.
const Footer = ({ domain }) => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer-root">
      <div className="footer-inner">
        <div className="footer-grid">
          {/* Brand */}
          <div>
            <Link
              to="/"
              className="text-decoration-none"
              style={{ display: "inline-block", marginBottom: 16 }}
            >
              <img
                src="/images/bleeplogo_dark.png"
                alt="BLEEP"
                style={{ height: 40, display: "block" }}
              />
            </Link>
            <p className="footer-blurb">
              Crowdsourced anti-counterfeit reporting. Helping keep products
              authentic and people safe.
            </p>
          </div>

          {/* Company */}
          <div>
            <div className="footer-col-label">Company</div>
            <ul className="footer-list">
              <li>
                <Link
                  to="/"
                  className="footer-link"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/bleeps"
                  className="footer-link"
                >
                  Latest BLEEPs
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="footer-link"
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/cbqs"
                  className="footer-link"
                >
                  CBQs
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="footer-link"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <div className="footer-col-label">Legal</div>
            <ul className="footer-list">
              <li>
                <Link
                  to="/termsofservice"
                  className="footer-link"
                >
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link
                  to="/privacypolicy"
                  className="footer-link"
                >
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Socials on the left, app badges on the right */}
        <div className="footer-utility">
          <div className="footer-social">
            {SOCIALS.map(({ href, icon, label }) => (
              <a
                key={href}
                href={href}
                className="footer-social-btn"
                aria-label={label}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className={icon} />
              </a>
            ))}
          </div>

          <div className="footer-apps">
            <span className="footer-apps__label">Download the BLEEP App:</span>
            <div className="footer-apps__badges">
              <a
                href="https://apps.apple.com/ca/app/bleep-report-now/id6751865451"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-app-badge"
              >
                <img
                  src="/images/appstore_btn.png"
                  alt="Download on the App Store"
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.acha.BLEEP"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-app-badge"
              >
                <img
                  src="/images/getitongoogleplaybadge.png"
                  alt="Get it on Google Play"
                />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Oversized wordmark. Decorative only: the real logo is in the brand
          column above, so this is hidden from assistive tech and unselectable. */}
      <div
        className="footer-wordmark"
        aria-hidden="true"
      >
        BLEEP!
      </div>

      <div className="footer-bottom">
        <span>
          © {year} BLEEP, Anti-Counterfeit Network Africa. All rights reserved.
        </span>
        {domain && <span className="footer-bottom__domain">{domain}</span>}
      </div>
    </footer>
  );
};

export default Footer;
